import { Component, OnInit } from '@angular/core';
import { NavController, Platform, ToastController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { AppState } from '../../../angular-wallet-base/store/appState';
import { getSetupPin, getOldPin } from '../../../angular-wallet-base/store/setup';
import { WalletService } from '../../../angular-wallet-base/services/wallet.service';
import { ActivatedRoute } from '@angular/router';
import { SetSetupMnemonicAction, CompleteSetupAction } from '../../../angular-wallet-base/actions/setup.actions';
import { SubscriptionListenerComponent } from '../../../angular-wallet-base/SubscriptionListenerComponent';
import { generateMnemonic } from '../../../angular-wallet-base/lib/pangolin/keyring/keychainUtils';
import { Logger } from '../../../angular-wallet-base/services/logger.service';
import { AUTH_REASON } from '../../../angular-wallet-base/constants';
import { TranslateService } from '@ngx-translate/core';
import { BiometricAuthService } from '../../../angular-wallet-base/services/biometric-auth.service';
import { getToastPosition } from '../../../angular-wallet-base/utils';
import { AppModeService } from '../../../angular-wallet-base/services/app-mode.service';

@Component({
  selector: 'confirm-pin',
  templateUrl: 'confirm-pin.page.html',
  styleUrls: ['confirm-pin.page.scss']
})
export class ConfirmPinPage extends SubscriptionListenerComponent implements OnInit {

  private confirmPin: string;
  private oldPin: string;
  public showPinError = false;
  public pin: string = '';
  readonly type: string;
  public restorePin: boolean = false;
  public isDesktopMode;

  constructor(private nav: NavController,
              public store: Store<AppState>,
              private route: ActivatedRoute,
              private wallet: WalletService,
              private toast: ToastController,
              private appMode: AppModeService,
              private translate: TranslateService,
              private bauth: BiometricAuthService,
              private platform: Platform) {
    super(store);
    this.appMode.isDesktopMode.subscribe(mode => this.isDesktopMode = mode);
    this.type = this.route.snapshot.params['type'] ? this.route.snapshot.params['type'] : 'new';
    this.restorePin = this.route.snapshot.queryParams['restore'] ? true : false;
  }

  ngAfterViewInit() {
    Logger.info('will enter', this.pin);
    this.pin = '';
  }

  ngOnInit() {
    this.subscriptions.add(this.store.select(getSetupPin).subscribe(pin => {
      this.confirmPin = pin;
    }));
    this.subscriptions.add(this.store.select(getOldPin).subscribe(pin => {
      this.oldPin = pin;
    }));
  }

  async handlePin(pin) {
    this.pin = pin;
    if (this.confirmPin !== pin) {
      this.showPinError = true;
    } else {
      if (this.type === 'new') {
        const mnemonic = await generateMnemonic();
        this.store.dispatch(new SetSetupMnemonicAction({ mnemonic }));
        await this.nav.navigateForward('/setup/setup-recovery-phrase');
      } else if (this.type === AUTH_REASON.CHANGE_PIN) {
        const success = await this.wallet.changeWalletPassword(this.oldPin, this.pin);
        
        if (!success) {
          const errorToast = await this.toast.create({
            header: await this.translate.get('settings.change_pin.error_title').toPromise(),
            message: await this.translate.get('settings.change_pin.error_message').toPromise(),
            position: getToastPosition(this.platform),
            duration: 4000
          });
          await errorToast.present();
        }

        const isBauthActive = await this.bauth.isActive();

        if (isBauthActive) {
          Logger.info('showing bauth');
          await this.bauth.activateBiometric(this.pin);
        }

        Logger.info('bauth passed');

        this.store.dispatch(new CompleteSetupAction());

        await this.nav.navigateForward('/wallet/settings');
      } else {
        await this.nav.navigateForward(`/setup/enter-recovery-phrase/${this.type}`);
      }
    }
  }

  handlePinClear(event) {
    this.showPinError = false;
  }
}
